import { PaginatedRequestParams } from 'api';

export const DocumentQueryKeys = {
  all: ['wallet'] as const,
  lists: () => [...DocumentQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...DocumentQueryKeys.lists(), filters] as const,
  details: () => [...DocumentQueryKeys.all, 'detail'] as const,
  detail: (id: string, params?: PaginatedRequestParams) =>
    [...DocumentQueryKeys.details(), id, params] as const,
};
